import React, { useContext, useEffect } from 'react';
import { UserContext } from '../../UserContext';
import AppointmentBooked, { appointmentBookedViewModel } from './AppointmentBooked';

declare global {
  interface Window {
    CE_API?: Array<() => void>;
  }
  const CE2: {
    converted: (id: string) => void;
  };
}

const useCrazyEgg = () => {
  useEffect(() => {
    (window.CE_API || (window.CE_API = [])).push(function () {
      CE2.converted('72724369-0bb1-42e6-9fb6-d219317d78e9');
    });
  }, []);
};

const AppointmentBookedScreen: React.FC = () => {
  useCrazyEgg();

  const userContext = useContext(UserContext);

  if (!userContext) return null;

  const { userData } = userContext;
  const viewModel = appointmentBookedViewModel(userData);

  return <AppointmentBooked viewModel={viewModel} />;
};

export default AppointmentBookedScreen;
